// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"4":"199b88f1","120":"50925016","856":"8f10e0c6"}[chunkId] + ".js";
};